import "./SpinnyCircle.css";
import { ReactComponent as CircleElement } from "./static/icons/CircleElement1.svg";

const SCROLL_TO_ANGLE_RATIO = 1;
const GROWTH_SPEED = 3;
const TOP_NAV_HEIGHT = 54;

const getGrowingDimensions = (
  relativeScrollPosition,
  growthSpeed,
  startSize
) => {
  return Math.max(Number(relativeScrollPosition * growthSpeed), startSize);
};

function SpinnyCircle({
  startAngle = 0,
  maxHeight = window.innerHeight,
  maxWidth = window.innerHeight,
  counterClockwise,
  scrollPosition,
  slideNumber,
  shrinking = false,
  Shape = CircleElement,
  growthSpeed = GROWTH_SPEED,
  startSize = 10,
  spinnySpeed = SCROLL_TO_ANGLE_RATIO,
}) {
  const relativeScrollPosition =
    startSize == maxWidth && startSize == maxHeight
      ? scrollPosition - TOP_NAV_HEIGHT
      : scrollPosition - slideNumber * window.innerHeight - TOP_NAV_HEIGHT;

  const height = Math.min(
    getGrowingDimensions(relativeScrollPosition, growthSpeed, startSize),
    maxHeight,
    window.innerHeight
  );
  const width = Math.min(
    getGrowingDimensions(relativeScrollPosition, growthSpeed, startSize),
    maxWidth,
    window.innerHeight
  );
  const angle = (startAngle + relativeScrollPosition / spinnySpeed) % 360;

  if (!shrinking && (width <= 10 || height <= 10)) {
    return;
  }

  return (
    <Shape
      className="spinnyCircle"
      style={{
        width: shrinking ? maxWidth : 10,
        height: shrinking ? maxHeight : 10,
        transform: `rotate(${counterClockwise ? "-" : ""}${angle}deg) scale(${
          shrinking ? 3 / Math.max(width / 40, 1) : width / 10
        }, ${shrinking ? 3 / Math.max(height / 40, 1) : height / 10})`,
      }}
    ></Shape>
  );
}

export default SpinnyCircle;
